import CountByDeviceBarChart from './CountByDeviceBarChart';
export default CountByDeviceBarChart;



// WEBPACK FOOTER //
// ./src/components/CountByDeviceBarChart/index.js